import {
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";

import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Submitted from "./pages/submit";
import Departments from "./pages/departmentsPage";
import Review from "./pages/reviewform";
import Search from "./pages/mainPage";
import CoursePage from "./pages/coursePage";
import Navbar from "./components/navBar";
import DeptPage from "./pages/departmentPage"
import NotFound from "./pages/notFound"
import Footer from "./components/footer"

function App() {
  return (
    <Box textAlign="top" fontSize="xl" minHeight="100vh" display="flex" flexDirection="column">
      <BrowserRouter>
        <Navbar />
        <Box flexGrow={1}>
          <Routes>
            <Route path="/" element={<Search />} exact={true}/>
            <Route path="/departments" element={<Departments />} exact={true} />
            <Route path="/departments/:departmentName" element={<DeptPage />} exact={true}/>
            <Route path="/departments/:departmentName/:courseName" element={<CoursePage />} exact={true}/>
            <Route path="/reviewform" element={<Review />} exact={true}/>
            <Route path="/submit" element={<Submitted />} exact={true}/>
            <Route path = "*" element={<NotFound />} />
          </Routes>
        </Box>
        <Footer />
      </BrowserRouter>
    </Box>
  );
}

export default App;

// import {
//   Routes,
//   Route,
//   BrowserRouter,
// } from "react-router-dom";

// import { Box } from "@chakra-ui/react";
// import { useEffect, useState } from "react";
// import Submitted from "./pages/submit";
// import Departments from "./pages/departmentsPage";
// import Review from "./pages/reviewform";
// import Search from "./pages/mainPage";
// import Display from "./pages/coursePage";
// import Navbar from "./components/navBar";
// import DeptPage from "./components/departmentPage"
// import Footer from "./components/footer";

// function App() {
//   return (
//     <Box textAlign="top" fontSize="xl">
//       <BrowserRouter>
//       <Navbar />
//         <Routes>
//           <Route path="/" element={<Search />} />
//           {/* <Route path="/:university/departments/:deptName/:courseName" component={deptPage} />*/}
//           <Route path="/departments" element={<Departments />} />
//           <Route path="/departments/:departmentName" element={<DeptPage />}/>
//           <Route path="/coursePage" element={<Display />} />
//           <Route path="/reviewform" element={<Review />} />
//           <Route path="/submit" element={<Submitted />} />
//           {/* <Route path = "*" element={<NotFound />} /> */}
//         </Routes>
//       </BrowserRouter>
//       <Footer />
//     </Box>
//   );
// }

// export default App;